import apiClient from "./config";
import { NOTIFICATION_ENDPOINTS } from "./endpoints";

const notificationService = {
  notificationList: (payload) => {
    return apiClient.post(NOTIFICATION_ENDPOINTS.NOTIFICATION_LIST, payload);
  },
  bulkUpdate: (payload) => {
    return apiClient.post(NOTIFICATION_ENDPOINTS.BULK_UPDATE, payload);
  },
  MarkReadAllNotification: () => {
    return apiClient.get(NOTIFICATION_ENDPOINTS.READALL_NOTIFICATION);
  },
  getNotificationPreferencesCategories: () => {
    return apiClient.get(
      NOTIFICATION_ENDPOINTS.GET_NOTIFICATION_PREFERANCE_CATEGORY,
    );
  },
  notificationPreferences: () => {
    return apiClient.get(NOTIFICATION_ENDPOINTS.NOTIFICATION_PREFERANCE);
  },
  enableNotification: (data) => {
    return apiClient.post(NOTIFICATION_ENDPOINTS.ENABLE_ALL_NOTIFICATION, data);
  },
  disableNotification: (data) => {
    return apiClient.post(
      NOTIFICATION_ENDPOINTS.DISABLE_ALL_NOTIFICATION,
      data,
    );
  },
  updateNotificationPreference: (category, payload) => {
    return apiClient.put(
      `${NOTIFICATION_ENDPOINTS.UPDATE_NOTIFICATION_CATEGORY}/${category}`,
      payload,
    );
  },
};

export default notificationService;
